import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LecturerService {


  url = environment.serverAPI4 + "/api/lecturerIdx";

  constructor(private http: HttpClient) { }

  getAllLecturer(Page: any, size: any, sort: any , supplierType:any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}&typeId=${supplierType}`);
  }

  getAllLecturerDropDown(supplierType:any): Observable<Object> {
    return this.http.get(`${this.url}/dropdown?typeId=${supplierType}`);
  }


  getLecturerById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }

  addOrEditLecturer(lecturerIdx: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, lecturerIdx);
  }

  LecturerSearch(query, Page: any, size: any, sort: any , supplierType:any ): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}&typeId=${supplierType}`);
  }

  downLecturerReportTemplate(): Observable<any> {
    return this.http.get(`${this.url}/template/download`, { responseType: 'arraybuffer', observe: 'response' });
  }

  downLecturerReport() {
    return this.http.get(`${this.url}/exceltemplate/export`, { responseType: 'arraybuffer', observe: 'response' });
  }
}
